import {
	SET_PREVIEW_IMAGE,
} from './action-types';

export function setPreviewImageAction({ isVisible, currentImageId = '' }) {
	return {
		type: SET_PREVIEW_IMAGE,
		isVisible,
		currentImageId,
	};
}
